/**
 * Customer Portal Dashboard Constants
 */

import type { DatePreset, DateRange } from '../types'

// ============================================
// API Endpoints
// ============================================

export const DASHBOARD_ENDPOINTS = {
  DASHBOARD: '/api/customer-portal-dashboard',
  CHART: '/api/customer-portal-dashboard/chart',
  LIVE_FEED: '/api/customer-portal-dashboard/live-feed',
  RANKINGS: '/api/customer-portal-dashboard/rankings',
  FACTORY_DETAIL: '/api/customer-portal-dashboard/factory-detail',
  CUSTOMER_DETAIL: '/api/customer-portal-dashboard/customer-detail',
  PRODUCT_DETAIL: '/api/customer-portal-dashboard/product-detail',
  CITY_DETAIL: '/api/customer-portal-dashboard/city-detail',
  ORDERS_VALUE: '/api/customer-portal-dashboard/orders-value',
} as const

export const LIVE_FEED_REFRESH_INTERVAL_MS = 30 * 1000 // 30 seconds

// ============================================
// Date Presets Configuration
// ============================================

export const DATE_PRESETS: Record<DatePreset, { labelKey: string }> = {
  today: { labelKey: 'dashboard.dateRange.today' },
  this_week: { labelKey: 'dashboard.dateRange.thisWeek' },
  this_month: { labelKey: 'dashboard.dateRange.thisMonth' },
  this_quarter: { labelKey: 'dashboard.dateRange.thisQuarter' },
  this_year: { labelKey: 'dashboard.dateRange.thisYear' },
  last_30_days: { labelKey: 'dashboard.dateRange.last30Days' },
  custom: { labelKey: 'dashboard.dateRange.custom' },
} as const

export const DEFAULT_DATE_PRESET: DatePreset = 'this_month'

export const DEFAULT_DATE_RANGE: DateRange = {
  preset: DEFAULT_DATE_PRESET,
  from: null,
  to: null,
}

// ============================================
// Currency
// ============================================

export const DEFAULT_CURRENCY = 'SAR'

// ============================================
// Refresh Interval
// ============================================

export const DASHBOARD_REFRESH_INTERVAL_MS = 5 * 60 * 1000 // 5 minutes
